import React, { useState } from 'react'
import {
	Card,
	CardHeader,
	CardContent,
	Collapse,
	IconButton,
	makeStyles,
	MenuItem,
	TextField
} from '@material-ui/core'

import { ExpandMoreOutlined } from '@material-ui/icons'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			marginBottom: 0
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '424px !important'
		},
		marginBottom: '23px'
	}
}))

const PetHomeServicesCard = (props) => {
	const classes = useStyles()

	let { pet, setPet } = props

	const [isExpanded, setIsExpanded] = useState(false)

	const petClassOptions = [
		{ id: 1, name: 'Green' },
		{ id: 2, name: 'Yellow' },
		{ id: 3, name: 'Red' }
	]

	return (
		<Card>
			<CardHeader
				className={classes.header}
				title="Home Services"
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, { [classes.expandOpen]: isExpanded })}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					<div className={classes.grid}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								select
								label="Pet Class"
								variant="filled"
								value={pet.pet_class ? petClassOptions.find((c) => c.id === pet.pet_class.id) : ''}
								disabled={!pet.active}
								onChange={(e) => setPet({ ...pet, pet_class: e.target.value })}>
								{petClassOptions.map((option) => (
									<MenuItem key={option.id} value={option}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								label="Pet Class Notes"
								variant="filled"
								value={pet.pet_class_notes}
								disabled={!pet.active}
								onChange={(e) => setPet({ ...pet, pet_class_notes: e.target.value })}
							/>
						</div>
						{/* <div className={ clsx([ classes.fieldWrapper, 'field-wrapper' ]) }>
              <TextField
                select
                label="Pet Containment"
                variant="filled"
                value={ pet.pet_containment }
                onChange={ e => setPet({ ...pet, pet_containment: e.target.value }) }
              >
                { petClassOptions.map(option => (
                  <MenuItem key={ option.id } value={ option }>
                    { option.name }
                  </MenuItem>
                )) }
              </TextField>
            </div> */}
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Pet Location"
							variant="filled"
							fullWidth
							value={pet.pet_location}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, pet_location: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Leash / Collar Information"
							variant="filled"
							fullWidth
							value={pet.leash_collar}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, leash_collar: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Harness Information"
							variant="filled"
							fullWidth
							value={pet.harness}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, harness: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Toy Information"
							variant="filled"
							fullWidth
							value={pet.toy_info}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, toy_info: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Personality"
							variant="filled"
							fullWidth
							value={pet.personality}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, personality: e.target.value })}
						/>
					</div>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default PetHomeServicesCard
